import { useEditor } from '@tiptap/react';
import type { Editor } from '@tiptap/react';
import { useEffect } from 'react';
import { useIntl } from 'react-intl';

import { useArticleEditor } from '../..';
import { getExcerpt } from '../../utils';

import { getExtensions } from './extensions';
import type { ExtensionsOptions } from './extensions';

type UseArticleEditorOptions = {
  isExcerpt?: boolean;
  excerptMaxChars?: number;
};

type UseArticleEditorProps = {
  options?: UseArticleEditorOptions;
  extensionsOptions?: ExtensionsOptions;
};

export const useArticleTiptapEditor = (
  editable: boolean,
  config?: UseArticleEditorProps
): Editor | null => {
  const intl = useIntl();
  const { article, updateContent } = useArticleEditor();

  const editor = useEditor({
    content: article.content,
    extensions: getExtensions({ ...config?.extensionsOptions, intl }),
    editorProps: {
      attributes: {
        role: 'textbox',
        'data-qa': 'article-editor',
      },
    },
    editable,
    onUpdate: ({ editor }) => updateContent(editor.getJSON()),
  });

  useEffect(() => {
    if (editor && !editable && article.content) {
      editor.commands.setContent(article.content);
    }
  }, [editor, article.content, editable]);

  if (!editor) {
    return null;
  }

  if (config?.options?.isExcerpt) {
    const excerpt = getExcerpt(
      editor.getText(),
      config?.options?.excerptMaxChars
    );
    editor.commands.setContent(excerpt);
  }

  return editor;
};
